import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Card, CardBody, Col } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import FunctionalityItemLink from './components/FunctionalityItemLink';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import GraphQL from '../../GraphQL';
import { getCurrentVersion } from '../../shared/utils/smartutils';

class FunctionalityPanel extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      listFunctionalityGroupByUser: [],
    };
  }

  componentDidMount = () => {
    const { dispatch } = this.props;
    dispatch(changeLoadingTrue());
    const accessDataQuery =
      '{listFunctionalityColumnsByUser(type: "PACO") {column,functionalitiesGroup{id, name, key, listOfFunctionalities{id, name, route, key, reportKey, icon}}}}';
    GraphQL(accessDataQuery, {})
      .then((res) => {
        this.setState({
          listFunctionalityGroupByUser: res.listFunctionalityColumnsByUser,
        });
        dispatch(changeLoadingFalse());
      })
      .catch((erro) => {
        dispatch(changeLoadingFalse());
        console.error(erro);
      });
  };

  render() {
    const { listFunctionalityGroupByUser } = this.state;
    const { t } = this.props;
    const panelContent = listFunctionalityGroupByUser.map((func) => (
      <div key={uuid()}>
        {func.functionalitiesGroup.map((itemCol) => (
          <div className="masonry-brick" key={itemCol.key}>
            <div className="functionality__column">
              {itemCol.name}
              {itemCol.listOfFunctionalities.map((funcC) =>
                funcC.route ? (
                  <FunctionalityItemLink
                    title={funcC.name}
                    to={funcC.route}
                    key={funcC.key}
                    icon={funcC.icon}
                  />
                ) : null
              )}
            </div>
          </div>
        ))}
      </div>
    ));

    return (
      <Col md={12} className="pt-4">
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">{t('panels.controlpanel')}</h5>
            </div>
            <div className="masonry-grid">{panelContent}</div>
            <div className="text-right">{getCurrentVersion()}</div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(FunctionalityPanel)
);
